import { DatePickerInput, type DatePickerInputProps } from '@mantine/dates';
import { dateToIso, isoToDate } from '../lib/format';

/**
 * Datumsfeld (D-M0-K1 D3; N7): **reiner Kalender-Picker** (`DatePickerInput`) —
 * kein Tippen, die Auswahl kommt ausschließlich aus dem Kalender (Faruq-Entscheid,
 * manuelle String-Eingabe soll weg). Anzeige TT.MM.JJJJ; nach außen spricht das
 * Feld weiter reines **ISO** (`value` ist ISO oder ''; `onChange` liefert ISO
 * oder '' beim Leeren) — alle Konsumenten bleiben unverändert.
 */
export function DateInputDE({
  value,
  onChange,
  ...rest
}: { value: string; onChange: (iso: string) => void } & Omit<
  DatePickerInputProps,
  'value' | 'onChange'
>) {
  return (
    <DatePickerInput
      {...rest}
      value={isoToDate(value)}
      valueFormat="DD.MM.YYYY"
      placeholder={rest.placeholder ?? 'TT.MM.JJJJ'}
      clearable={rest.clearable ?? true}
      onChange={(d) => onChange(dateToIso(d as Date | null))}
    />
  );
}
